import {
  SURVEY_STATUS_OPEN,
  SURVEY_STATUS_DRAFT,
  SURVEY_STATUS_PAUSED,
  SURVEY_STATUS_CLOSED,
  SURVEY_STATUS_ARCHIVED,
} from 'sharedParts';

export const statusLabelMap = {
  [SURVEY_STATUS_OPEN]: 'Open',
  [SURVEY_STATUS_DRAFT]: 'Draft',
  [SURVEY_STATUS_PAUSED]: 'Pause',
  [SURVEY_STATUS_CLOSED]: 'Close',
  [SURVEY_STATUS_ARCHIVED]: 'Archive',
};

export default [
  {
    value: SURVEY_STATUS_OPEN,
    label: statusLabelMap[SURVEY_STATUS_OPEN],
    allowedStatuses: [SURVEY_STATUS_PAUSED, SURVEY_STATUS_CLOSED],
    confirmationRequiredStatuses: [
      SURVEY_STATUS_DRAFT,
      SURVEY_STATUS_PAUSED,
      SURVEY_STATUS_CLOSED,
    ],
    heading: '',
    confirmButtonText: '',
  },
  {
    value: SURVEY_STATUS_DRAFT,
    label: statusLabelMap[SURVEY_STATUS_DRAFT],
    allowedStatuses: [SURVEY_STATUS_OPEN, SURVEY_STATUS_CLOSED],
    confirmationRequiredStatuses: [SURVEY_STATUS_CLOSED],
    heading: 'Are you sure you want to make this survey a draft?',
    confirmButtonText: 'Make a Draft',
  },
  {
    value: SURVEY_STATUS_PAUSED,
    label: statusLabelMap[SURVEY_STATUS_PAUSED],
    allowedStatuses: [SURVEY_STATUS_OPEN, SURVEY_STATUS_CLOSED],
    confirmationRequiredStatuses: [SURVEY_STATUS_CLOSED],
    heading: 'Are you sure you want to pause this survey?',
    confirmButtonText: 'Pause Survey',
  },
  {
    value: SURVEY_STATUS_CLOSED,
    label: statusLabelMap[SURVEY_STATUS_CLOSED],
    allowedStatuses: [],
    confirmationRequiredStatuses: [],
    heading: 'Are you sure you want to close this survey?',
    confirmButtonText: 'Close Survey',
  },
  {
    value: SURVEY_STATUS_ARCHIVED,
    label: statusLabelMap[SURVEY_STATUS_ARCHIVED],
    allowedStatuses: [SURVEY_STATUS_DRAFT],
    confirmationRequiredStatuses: [],
    heading: 'Are you sure you want to archive this survey?',
    confirmButtonText: 'Archive Survey',
  },
];
